// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgBoilerServiceIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M10.01 21c0 .55-.45 1-1 1s-1-.45-1-1v-1h2zm6 0c0 .55-.45 1-1 1s-1-.45-1-1v-1h2zM17 3c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1zm-5 3a.5.5 0 0 0-.31.11C11.58 6.2 9 8.31 9 11s2.58 4.8 2.69 4.89c.09.07.2.11.31.11s.22-.04.31-.11C12.42 15.8 15 13.69 15 11s-2.58-4.8-2.69-4.89A.5.5 0 0 0 12 6m0 4s1 1.12 1 2.5-1 2.5-1 2.5-1-1.12-1-2.5 1-2.5 1-2.5" />
  </g>
);
export default SvgBoilerServiceIcon;
SvgBoilerServiceIcon.displayName = 'SvgBoilerServiceIcon';
